import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Webnar } from '../models/webnar';
import { Observable } from 'rxjs';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';

@Injectable({
  providedIn: 'root'
})
export class WebnarService {

  public objectImage: any = null; // store input file for avatar
  public storedImage: any; // store url image for local preview

  private itemDoc: AngularFirestoreDocument<Webnar>;
  private item: Observable<Webnar>;

  constructor(private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService) { }

  select() {
        return this.db.collection<Webnar>('sbccv_webinars', ref => ref.orderBy('name', 'asc')).snapshotChanges();            
  }

  selectById(id) {
    this.itemDoc = this.db.doc<Webnar>('sbccv_webinars/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  insert(entity: Webnar) {
    delete entity.id;
    return this.db.collection('sbccv_webinars').add(Object.assign({}, entity));
  }

  update(entity: Webnar) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('sbccv_webinars').doc(id).set(Object.assign({}, entity));
  }

  delete(entity_id: any) {
    return this.db.collection('sbccv_webinars').doc(entity_id).delete();
  }

  makeMsgError(errorsCode) {
    let msgError: string = errorsCode

    switch (errorsCode) {
      case "":
        msgError = ""//"Este email já está em uso"
        break;
    }
    
    return msgError
  }

}

